import React from "react";
import customerSupportImg from "../../../../assets/images/services-marketing.jpg";

const CustomerSupportSection = () => {
  return (
    <section className="bg-white p-6 md:p-10">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between">
        <div className="text-center md:w-1/2 mb-6 md:mb-0 ml-8 md:ml-9">
          <h2 className="text-2xl md:text-3xl font-bold text-black mb-3">
          Put repetitive tasks on autopilot
          </h2>
          <p className="text-base md:text-lg text-black">
          You're not in the business of preparing documents, filling spreadsheets, copying data, or writing the same emails every day.
          You are in the business of delivering results to your clients.<br></br>
          More focus on strategic work vs. manual work<br></br>
          No more bottlenecks or delays<br></br>
          Higher output per employee<br></br>
          </p>
        </div>

        <div className="md:w-1/2 flex items-center justify-center">
          <img
            src={customerSupportImg}
            alt="Chat interface"
            className="w-100 md:w-100 max-w-xs shadow-lg rounded-lg"
          />
        </div>
      </div>
    </section>
  );
};

export default CustomerSupportSection;
